import { AllTypeWidgets, WidgetCategory } from '../../types';
import BarWidget from './BarWidget/BarWidget';
import LineWidget from './LineWidget';
import PieWidget from './PieWidget';
import TableWidget from './TableWidget';
import TextWidget from './TextWidget';
import TileWidget from './TileWidget';

type RenderWidgetProps = {
  widget: AllTypeWidgets;
  setWidget?: (v: AllTypeWidgets) => void;
  onSelect?: (v: AllTypeWidgets) => void;
};

const RenderWidget = ({ widget, setWidget, onSelect }: RenderWidgetProps) => {
  switch (widget.category) {
    case WidgetCategory.Table:
      return <TableWidget widget={widget} setWidget={setWidget} onSelect={onSelect} />;
    case WidgetCategory.Pie:
      return <PieWidget widget={widget} onSelect={onSelect} />;
    case WidgetCategory.Bar:
      return <BarWidget widget={widget} onSelect={onSelect} />;
    case WidgetCategory.Line:
      return <LineWidget widget={widget} onSelect={onSelect} />;
    case WidgetCategory.Text:
      return <TextWidget widget={widget} />;
    case WidgetCategory.Tile:
      return <TileWidget widget={widget} onSelect={onSelect} />;
    default:
      return undefined;
  }
};

export default RenderWidget;
